import { z } from 'zod'

export const inviteSchema = z.object({
  email: z.email('Bitte geben Sie eine gültige E-Mail-Adresse ein.'),
  fullName: z.string().trim().min(2, 'Bitte geben Sie den vollständigen Namen ein.'),
  role: z.string().min(1, 'Bitte wählen Sie eine Rolle.'),
})

export type InviteInput = z.infer<typeof inviteSchema>
